import React, { useState } from "react";

export default function InviteCodeSection({ inviteCode, companyName }) {
  const [codeCopied, setCodeCopied] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);

  // Format code as ABCD-1234
  const formatCode = (code) => {
    if (!code) return "N/A";
    const clean = code.replace(/-/g, "").toUpperCase();
    if (clean.length >= 8) {
      return `${clean.slice(0, 4)}-${clean.slice(4, 8)}`;
    }
    return clean;
  };

  // Generate shareable link
  const shareLink = inviteCode
    ? `${window.location.origin}/#/join-company?code=${inviteCode}`
    : "";

  const handleCopyCode = async () => {
    if (!inviteCode) return;
    try {
      await navigator.clipboard.writeText(inviteCode);
      setCodeCopied(true);
      setTimeout(() => setCodeCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy code:", err);
    }
  };

  const handleCopyLink = async () => {
    if (!shareLink) return;
    try {
      await navigator.clipboard.writeText(shareLink);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };

  return (
    <section className="team-section">
      <div className="team-section-header">
        <div>
          <h2 className="team-section-title">Invite Team Members</h2>
          <p className="team-section-subtitle">
            Share this code with employees to join {companyName || "your company"}
          </p>
        </div>
      </div>

      {/* Invite Code Display */}
      <div className="invite-code-display">
        <span className="invite-code-value">{formatCode(inviteCode)}</span>
        <button className="btn-copy" onClick={handleCopyCode}>
          {codeCopied ? "Copied!" : "Copy Code"}
        </button>
      </div>

      {/* Shareable Link */}
      <div className="invite-link-wrapper">
        <input
          type="text"
          value={shareLink}
          readOnly
          placeholder="Invite link will appear here"
        />
        <button className="btn-copy-link" onClick={handleCopyLink}>
          {linkCopied ? "Copied!" : "Copy Link"}
        </button>
      </div>

      {(codeCopied || linkCopied) && (
        <p className="copy-success">Copied to clipboard!</p>
      )}
    </section>
  );
}
